import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MapResponse } from './models';

@Injectable({ providedIn: 'root' })
export class MapApiService {
  private readonly http = inject(HttpClient);
  /**
   * URL relativa para funcionar em dois cenarios:
   * - desenvolvimento local com proxy do Angular;
   * - HostGator/cPanel, com a API PHP dentro da pasta /api.
   */
  private readonly apiBaseUrl = 'api';

  getMap(): Observable<MapResponse> {
    return this.http.get<MapResponse>(`${this.apiBaseUrl}/map`);
  }
}
